

























































































































































import { Component, Prop, Vue } from "vue-property-decorator";

interface Description {
  id: string;
  title: string;
  descriptions: Array<Td>;
}
interface Td {
  id: string;
  title: string;
  image: string;
  comment: string;
  items: Array<string>;
  pres: Array<string>;
}

@Component
export default class ReinforcementComponent extends Vue {

  @Prop()
  //el: '#radio'
  private msg!: string;
  
  //mounted() {
  //  MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
  //},

private text1 = `
func getframes() {
	fmt.Println("getframes() 1.開始")

}`
  
private text2 = `
  func videoHandler(w http.ResponseWriter, r *http.Request) {
}`

  private contents1: Description = {
  	id: "1",
  	title: "強化学習の基礎",
  	descriptions: [
  	 {id: "1",
  	  title: "強化学習の概要",
  	  image: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/強化学習_2.png?alt=media",
  	  comment: "強化学習の概念図",
  	  items: [
  	  	"強化学習(reinforcement learning)とは機械学習の一種です。",
  	  	"どの様な結果が望ましいか定義された世界の中で、できるだけ少ない労力でその望ましい結果に至る様な行動とは何かを学習するものです。",
		"以下は強化学習の概念図です。",
		"①エージェント(agent)：報酬を最大限に得れると考える方策(ポリシー)に基づいて行動A(action)を決定します。",
		"②環境(environment)：エージェント(agent)の行動A(action)が環境の状態（Sate）に影響を与えます。",
		"③エージェント(agent)は、環境(environment)の状態（Sate）と報酬R(reward)を得て、次の行動を決定します。",
  	    ],
		pres: [],
  	 }, // end of id=1
	 {id: "2",
  	  title: "強化学習の種類",
  	  image: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/強化学習_1.png?alt=media",
  	  comment: "強化学習の種類",
  	  items: [
  	  	"強化学習の良否はいかに優れた方策を決定するかにかかっており、方策を学習するための様々な手法が提案されています。",
  	  	"以下はその手法の関係性を示した図例となります。",
  	    ],
		pres: [],
  	 }, // end of id=2
	 {id: "3",
  	  title: "価値ベースの手法と方策ベースの手法の比較",
  	  image: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/強化学習_3.png?alt=media",
  	  comment: "価値ベースの手法と方策ベースの手法の比較",
  	  items: [
  	  	"方策を学習する方法は大きく分けて2種類あります。",
  	  	".",
  	  	"【価値ベースの手法:Value-Based Method】",
  	  	"価値ベースの手法は、価値関数QをTD学習やモンテカルロ法などにより学習し、この関数のもとで最適な行動を決定します。",
  	  	"行動は決定論的となる傾向があります。",
  	  	"価値関数は、狙いの状態から逆算して、一つ前の状態、更に一つ前の状態が選択されるように報酬を与えます。",
  	  	".",
  	  	"【方策ベースの手法:Policy-Based Method】",
  	  	"方策ベースの方法は、方策の条件付き確率πを方策勾配法などにより学習し、価値関数を求めることなく直接的に方策を決定します。",
  	  	"条件付き確率は、早く狙いの状態に達した時の行動は重要だと考え、その行動を今後多く取り入れる様に計算します。",
  	  	"行動の選択は確率論的となります。",
  	    ],
		pres: [],
  	 }, // end of id=3
	 {id: "4",
  	  title: "方策ベースの手法の利点",
  	  image: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/強化学習_4.png?alt=media",
  	  comment: "方策ベースの手法の利点",
  	  items: [
  	  	"① 価値ベースの手法は役に立たない可能性のある膨大な各状態に対するアクション値を保存する必要がありますが、方策ベースの手法はそうすることなく、 最適なポリシーを直接推定できる。",
  	  	"② 方策ベースの手法は、連続的なアクションが存在する場合に最適で、真の確率的ポリシーを学習することができる。",
  	  	"③ 価値ベースは決定論的なアクションを取る傾向があるので、本来は異なる状態であるが観測上は同一の状態がある(Aliased state)場合には 同一のアクションとなるので、以下の例ではゴールに到達できない場合があります(ε-greedy法を使用すると、他の状態の場合で最適な行動をとれなくなる)。",
  	  	"   対して方策ベースは、同一の状態に対しても確率論的にアクションを選択できるので、ゴールにきちんと到達できます。",
  	  	"",
  	    ],
		pres: [],
  	 }, // end of id=4
  	]
  }
  
    private contents2: Description = {
  	id: "1",
  	title: "actor-critic方式",
  	descriptions: [
  	 {id: "1",
  	  title: "actor-critic方式とは",
  	  //image: require("../assets/webサーバ1.png"),
  	  image: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/actor_critic_01.jpg?alt=media",
  	  comment: "actor-critic方式",
  	  items: [
  	  	"アクタークリティックは行動を選択肢するアクター（actor）と、アクターが選択した行動を評価するクリティック(critic)で構成される強化学習のフレームワークの１つです。",
		"以下はイメージ図です。",
		"学習の流れはシンプルで、",
		".",
		"①：アクターは、方策π(s,a)をもとに行動を選択し、実行します。",
		"②：環境から状態s′及び報酬rをクリティックが観測します。",
		"③：得られた状態s′、報酬rを使ってアクターの取った行動を評価し、アクターに通知。アクターは評価をもとに方策の更新します。",
		".",
		"この①、②、③を繰り返します。",
  	    ],
		pres: [this.text1],
  	 }, // end of id=1
	 {id: "2",
  	  title: "Actor（行動器）",
  	  image: "",
  	  comment: "",
  	  items: [
  	  	"Webブラウザから「https://xxx/video」でアクセスした場合のvideoHandler()メソッドを作成します。",
  	  	"このハンドラでは「go getframes()」でgetframes()関数のgoroutineを起動しておきます。",
  	  	"その後、getframes()関数が作成したframeデータを端末（Webブラウザ）に送信し続けます。",
  	    ],
		pres: [this.text2],
  	 }, // end of id=2
	 {id: "3",
  	  title: "Critic（評価器）",
  	  image: "",
  	  comment: "",
  	  items: [
  	  	"当然ながら、クラウド上にあるWebサーバでは、Webカメラは接続されていない。",
  	  	"このハンドラでは「go getframes()」でgetframes()関数のgoroutineを起動しておきます。",
  	  	"その後、getframes()関数が作成したframeデータを端末（Webブラウザ）に送信し続けます。",
  	    ],
		pres: [],
  	 }, // end of id=3
  	]
  }
  
  private contents3: Description = {
  	id: "1",
  	title: "深層強化学習（A2C）",
  	descriptions: [
  	 {id: "1",
  	  title: "深層強化学習（A2C）とは",
  	  image: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/強化学習_5.png?alt=media",
  	  comment: "A2C型の分散強化学習は中央指令室だけがネットワークを持つ",
  	  items: [
  	  	"A2CはA3C(Asynchronous Advantage Actor Critic) の派生手法です。",
  	  	"A3Cでは並列化された各agentが自律的にrollout → 勾配計算し勾配情報だけをパラメータサーバに送付、という流れで分散学習を行います。",
  	  	"この方法では各agentがそれぞれ勾配計算を行うためGPUの数＝agentの数のときパフォーマンスが最大となります*1。",
  	  	"これはGPUリソースに乏しい一般人にはなかなか辛いアーキテクチャです。",
  	  	".",
  	  	"そこで、①中央指令室がすべてのagentに対してアクション指示を出す→②並列化された各agentは指示されたアクションで環境のstepを進める→③各agentは蓄積した遷移情報を中央指令室へ送信→④中央指令室が集められたトラジェクトリから勾配計算しネットワークを更新する、という流れで学習を行う派生手法が考案されました。",
  	  	"これなら推論、勾配計算をするのは＝GPUを使うのは中央指令室だけなので=GPUは１つでOKとなります。",
  	  ],
  	  pres: [],
  	 },// end of id=1
  	 {id: "2",
  	  title: "土佐藩参政の要職にあった福岡孝悌（藤次）の怪しい行動",
  	  image: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/強化学習_6.png?alt=media",
  	  comment: "怪しい福岡孝悌（藤次）",
  	  items: [
  	    "また後藤と同じ土佐藩参政の要職にあった福岡孝悌（藤次）は、公議政体論者で、龍馬の下宿近江屋の二軒隣に家を借り、龍馬とも親しく接していました。",
  	    "実は事件当日の午後、龍馬は福岡の下宿を訪ね、不在であったため、居合わせたお嘉代（かよ、後の福岡夫人）に近江屋に遊びに来るよう誘いますが、なぜか福岡の従者が止めています。",
  	    "その夜、福岡が帰宅すると、すでに龍馬は殺害されていました。",
  	    "しかし「坂本が殺された時、隣に福岡が下宿していたが見舞いもしなければ会葬もしない。",
  	    "どうも彼の気が知れない」と陸援隊にいた田中顕助（たなかけんすけ）が語っています。",
  	    "そのことをお嘉代が問うと、福岡は「お前の知ったことか」と激怒しました。",
  	    "この福岡の不可解な態度は何を意味するのでしょうか。",
  	    "そして事件当日に「新選組のしわざであろう」と日記に記した土佐藩側用役の寺村左膳。",
  	    "彼も公議政体論の支持者ですが、日記にこう書いています。",
  	    "「龍馬も中岡もこうした時勢なので藩は寛大にも黙認しているが、もともと脱藩者であり、いまだ復籍もしていないので、今回の事件について藩は表向き何ら関知しない」。",
  	    "龍馬も中岡も脱藩の罪はすでに赦免されていたはずですが、寺村は復籍していないとし、事件についてもはなはだ冷淡な態度です。",
  	  ],
  	  pres: [],
  	 },// end of id=2
  	 {id: "3",
  	  title: "坂本龍馬は、福岡孝悌（藤次）の命令で「お嘉代」に毒殺された？",
  	  image: "http://www.hiroict.com/files/talkai/Pictures/トークA愛/坂本龍馬京都1.gif",
  	  comment: "当時の京都の地図",
  	  items: [
  	    "福岡孝悌（藤次）は、海援隊の連中を京都東山にある「噲々樓（かいかいろう）」に招き酒を飲ませていた。",
  	    "この時、お酌をしていたのが、お嘉代（かよ、後の福岡夫人）であった。お嘉代は「山猫」と呼ばれていたらしい。。",
  	    "坂本龍馬が殺された慶応3年11月15日（1867年12月10日）は、坂本龍馬の誕生日であった。",
  	    "すると、この日は福岡孝悌（藤次）が坂本龍馬の誕生日パーティとして近江屋に坂本龍馬や中岡慎太郎らを呼んだ可能性が高い。",
  	    "福岡孝悌（藤次）の命令で、お嘉代が、近江屋の坂本龍馬と中岡慎太郎に毒を盛った可能性が高い。",
  	    "お嘉代は、このご褒美と口封じのために、この後、福岡孝悌（藤次）の第二夫人になった。",
  	    "勿論、坂本龍馬と中岡慎太郎の殺害命令は、上司の後藤象二郎から福岡孝悌（藤次）に出されていた。",
  	    "後藤象二郎は、上司の前土佐藩藩主の山内容堂から命令され、山内容堂は、薩摩藩（西郷隆盛）とその後ろにいる英国のパークス公使やアーネストサトウに命令されていた。",
  	  ],
  	  pres: [],
  	 },// end of id=3
  	 {id: "4",
  	  title: "鬼塚英昭「日本の本当の黒幕」に書かれた坂本龍馬暗殺犯",
  	  image: "",
  	  comment: "",
  	  items: [
  	    "龍馬が著した「閑愁録」（キリスト教で支配される危機感を綴った）に端を発している。",
  	    "これを知ったイギリス公使パークス、外交官アーネストサトウ、長崎で布教していたフルベッキ等が、龍馬暗殺を計画した。",
  	    "島津久光に「暗殺命令」を下し、西郷隆盛、大久保利通が動く。",
  	    "これを受けて薩摩藩士吉井幸輔（パークスのエージェント）が、土佐藩山内容堂、後藤象二郎に訴える。",
  	    "隠れキリシタンでもあった、容堂は、「龍馬のみならず、中岡慎太郎も消せ」と後藤象二郎に指示。",
  	    "後藤象二郎から、福岡孝悌、谷干城、に具体的なプランが指示されて、実動隊は、谷干城、田中光顕、陸奥宗光となった。",
  	  ],
  	  pres: [],
  	 },// end of id=4
  	 {id: "5",
  	  title: "「閑愁録」に書かれたキリスト教の悪口とは",
  	  image: "",
  	  comment: "",
  	  items: [
          "まさに今、西洋のキリスト教が開港された長崎や箱館や浦賀の三港において盛んに信仰されており、キリスト教の神父は絶対神の堂（天主堂）を建て、多くの愚かな民衆を惑わしている。",
          "特に長崎に於いてはそれが最も盛んである。",
          "最近、長崎の浦上や大浦の村民が競ってキリスト教の信者になり、合計すれば三千人に及んでいる。",
          "・・",
          "そのキリスト教の説く教えとは、神の教えを信じれば、救われる。",
          "そのような教えであるから、民法や刑法で取り締まり、刑罰を与えるとして禁止しても効果はない。"
        ],
  	  pres: [],
  	 },// end of id=5
  	],
  }

  private tabGroup: {
    "font-weight": "bold",
    "background": "#eee",
    "color": "red",
  };
  private isLarge: true;
  private isRed: true;
  private isUnderLine: true;
  private test: string;
  private isActive = "1";
  //private isActive: boolean[] //= [true, false, false, false] ;
  //private isActive0: boolean;
  //private isActive1: boolean;
  //private isActive2: boolean;
  //private isActive3: boolean;
  private color: "red";
  /*
  classObject: {
    isRed: true,
    'is-active': true
  }
  */
  /** ライフサイクルフック */
  public created() {
    window.console.log("created() 1.");
    this.isActive = "1";
    this.test = "test";
    //this.albums = [this.album_2, this.album_1];
    //this.firstImage();
  }

  // タブ切り替え
  private selectTab(index: number): void {
    window.console.log("selectTab() 1.index: " + index);
    this.isActive = "2";
    this.test = "test2";
    window.console.log("selectTab() 2.this.isActive: " + this.isActive);
  }

  private testProc() {
    this.isActive = "2";
    window.console.log("test() 1.this.isActive: " + this.isActive);
  }

  classObject() {
    return {
      isRed: this.isRed,
      "is-Active": this.isActive
    };
  }
} // end of export
